__turbopack_context__.v({
  "breadcrumb": "Breadcrumb-module__ns0fIG__breadcrumb",
});
